import * as React from "react";
import QuestionItem from "./item";

interface IProps {
  questions: ReadonlyArray<Vingle.QnA.IQuestion>;
  onLikeClick: (questionId: string, currentLikeState: boolean) => void;
}

class QuestionList extends React.PureComponent<IProps> {
  public render() {
    const { questions, onLikeClick } = this.props;

    if (questions.length > 0) {
      return (
        <div>
          {questions.map(question => {
            return (
              <QuestionItem
                key={`question_${question.id}`}
                question={question}
                onLikeClick={onLikeClick}
              />
            );
          })}
        </div>
      );
    }
    return null;
  }
}

export default QuestionList;
